(function () {
  document.documentElement.classList.add('lun-reveal-ready');

  // reveal on scroll
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('[data-lun-reveal]').forEach(function (el) { io.observe(el); });

  // count-up numbers
  function ease(t){ return 1 - Math.pow(1 - t, 4); }
  function run(el){
    var target = parseFloat((el.dataset.lunCount || '0').replace(/,/g, ''));
    var start = performance.now(), dur = 1800;
    function tick(now){
      var p = Math.min((now - start) / dur, 1);
      el.textContent = Math.floor(ease(p) * target).toLocaleString();
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  var cio = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { run(e.target); cio.unobserve(e.target); }
    });
  }, { threshold: 0.6 });
  document.querySelectorAll('[data-lun-count]').forEach(function (el) { cio.observe(el); });

  // subtle parallax on any hero / bleed background
  var layers = document.querySelectorAll('.lun-hero__bg, .lun-bleed__bg');
  if (layers.length) {
    window.addEventListener('scroll', function () {
      layers.forEach(function (bg) {
        var rect = bg.parentElement.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) {
          var shift = (rect.top * -0.12);
          bg.style.transform = 'scale(1.08) translateY(' + shift + 'px)';
        }
      });
    }, { passive: true });
  }
})();